import { useSelector, useDispatch } from "react-redux";
import { setBackLayout } from "../../redux/slice/system";
import { useNavigate } from "react-router-dom";
import { useClearLocalStorage } from "../hooks";

import { Button } from "primereact/button";

export default function BackTopbar(props) {
  let { LayoutCss } = props;
  const system = useSelector((state) => state.system);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const clearLocalStorage = useClearLocalStorage();
  const route_navigate = useNavigate();

  // 登出
  const logout = () => {
    clearLocalStorage();
    route_navigate("/login");
  };

  return (
    <>
      <div className={`${LayoutCss["layout-topbar"]}`}>
        <Button
          className="p-button-main p-button-sm w-auto px-2 py-1"
          icon="pi pi-bars"
          onClick={() =>
            dispatch(
              setBackLayout({
                isSideShow: !system.backLayout.isSideShow,
              })
            )
          }
        />
        {/* <span className={`${LayoutCss["layout-title"]}`}>
          Hello! {user.userDetail?.username} (admin)
        </span> */}

        {/* {process.env.REACT_APP_MODE === "development" && (
          <div className="inline-block text-center text-xl text-white bg-red-500 font-bold px-2 py-0 ml-4">
            測試站
          </div>
        )} */}

        <span className="text-main ml-auto">
          使用者：{user.userDetail?.username}
        </span>
        <Button
          className="p-button-main p-button-sm w-auto px-3 py-1 ml-3"
          label="登出"
          onClick={() => logout()}
        />
      </div>
    </>
  );
}
